import React from "react";
import "./styles/ItEnvironmentContent.scss";
import BannerType1 from "./BannerType1";
import { useTranslation } from "react-i18next";
const ItEnvironmentContent = () => {
  const { t } = useTranslation();
  const contents = t("consulting.environment.analysis.contents", { returnObjects: true }) as { path: string; name: string; list: string[] }[];
  return (
    <>
      <div className="it_environment_content_wrap">
        <BannerType1 path="/imgs/banner_it_environment.png" />
        <h2 className="title">{t("consulting.environment.analysis.title")}</h2>
        <div className="contents">
          <div className="des">{t("consulting.environment.analysis.des")}</div>
          <div className="card_wrap">
            {contents.map((content: { path: string; name: string; list: string[] }, index: number) => {
              return (
                <div className="card" key={`${content.name}_${index}`}>
                  <div className="img_box">
                    <img src={content.path} alt={content.name} />
                  </div>
                  <div className="name">{content.name}</div>
                  <ul>
                    {content.list.map((text: string, index: number) => {
                      return <li key={`${text}_${index}`}>{text}</li>;
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default ItEnvironmentContent;
